import { darken } from "@material-ui/core/styles/colorManipulator";
import bg from "../../styles/images/petal_bg.svg";

export const gradientBgLight = (theme: any) =>
  `linear-gradient(-45deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.main} 33%, ${
    theme.palette.secondary.main
  } 100%);`;
export const gradientBgDark = (theme: any) =>
  `linear-gradient(-45deg, ${darken(theme.palette.primary.main, 0.4)} 0%, ${darken(
    theme.palette.primary.main,
    0.4
  )} 33%, ${darken(theme.palette.secondary.main, 0.4)} 100%);`;

export const MARGEM_PAGINA = 40;
export const LARGURA_RAIL = 90;
export const LARGURA_SIDEBAR = 340;

export const MEDIA_ESCALA_LAYOUT = "@media (min-width:1280px)";

const appFrame = {
  display: "flex",
  width: "100%",
  minHeight: "100%",
  zIndex: 1
};

const styles = (theme: any) => ({
  root: {
    width: "100%",
    marginTop: 0,
    zIndex: 1,
    overflow: "auto"
  },
  blogWrap: {
    position: "relative"
  },
  appFrameInner: {
    ...appFrame,
    "--altura-tela": "100vh",
    [MEDIA_ESCALA_LAYOUT]: {
      zoom: "var(--escala-layout, 1)",
      "--altura-tela": "calc(100vh / var(--escala-layout, 1))"
    }
  },
  appFrameOuter: {
    ...appFrame
  },
  appFrameLanding: {
    backgroundColor: theme.palette.background.default,
    minHeight: 1000
  },
  appFrameSlider: {
    display: "flex",
    width: "100%",
    height: "100%",
    [theme.breakpoints.up("lg")]: {
      position: "absolute",
      overflow: "hidden"
    },
    backgroundColor: theme.palette.background.default
  },
  topNav: {
    flexDirection: "column"
  },
  sideNav: {
    flexDirection: "row"
  },
  content: {
    width: "100%",
    padding: theme.spacing(4),
    minHeight: "100%",
    overflow: "hidden",
    [theme.breakpoints.up("lg")]: {
      paddingLeft: MARGEM_PAGINA,
      paddingRight: MARGEM_PAGINA
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    [theme.breakpoints.down("xs")]: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5)
    }
  },
  petal: {
    background: `url(${bg}) no-repeat`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    width: "100%",
    height: "100%",
    position: "fixed"
  },
  outerContent: {
    width: "100%",
    backgroundSize: "cover",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  bgWrap: {
    position: "fixed",
    background: theme.palette.background.default,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0
  },
  headerBg: {},
  halfBg: {},
  fullBg: {},
  bgbar: {
    backgroundAttachment: "fixed",
    width: "100%",
    top: 0,
    left: 0,
    position: "absolute",
    "&$headerBg": {
      height: 64
    },
    "&$halfBg": {
      height: 400
    },
    "&$fullBg": {
      height: "100%"
    }
  },
  gradientBg: {
    backgroundImage: theme.palette.type === "dark" ? gradientBgDark(theme) : gradientBgLight(theme),
    backgroundAttachment: "fixed"
  },
  solidBg: {
    backgroundColor: theme.palette.background.default
  },
  decorationWave: {
    width: "100%",
    height: "auto",
    position: "absolute",
    left: -2,
    bottom: -32,
    transform: "scale(1.1,0.8)",
    transformOrigin: "bottom",
    [theme.breakpoints.down("xs")]: {
      display: "none"
    }
  },
  decorationPetal: {
    width: "100%",
    height: "auto",
    position: "absolute",
    left: 0,
    top: 0
  },
  sidebarLayout: {},
  topbarLayout: {},
  mainWrap: {
    height: "100%",
    position: "relative",
    "& > div": {
      willChange: "inherit !important" // hack for floating form issue when expaded
    },
    "&$sidebarLayout": {
      paddingTop: theme.spacing(5)
    },
    "&$topbarLayout": {
      width: "100%",
      marginTop: theme.spacing(3)
    }
  },
  preloader: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1000,
    background: "transparent",
    height: 3
  },
  materialBg: {
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    opacity: 0.5
  },
  // o recuo so existe para o rail da sidebar permanente, que abaixo de lg da lugar ao
  // drawer temporario; sem o breakpoint o conteudo recuava sem sidebar nenhuma
  contentPaddingLeft: {
    [theme.breakpoints.up("lg")]: {
      paddingLeft: LARGURA_RAIL + MARGEM_PAGINA,
      transition: theme.transitions.create("padding-left", {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.leavingScreen
      })
    }
  },
  // sidebar fechada (rail) expandida por hover: o conteudo acompanha a largura do drawer
  contentPaddingLeftHover: {
    [theme.breakpoints.up("lg")]: {
      paddingLeft: LARGURA_SIDEBAR + MARGEM_PAGINA,
      transition: theme.transitions.create("padding-left", {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.enteringScreen
      })
    }
  },
  contentPaddingRight: {
    paddingRight: 80
  },
  hideApp: {
    display: "none"
  },
  circularProgress: {
    position: "fixed",
    top: "calc(50% - 45px)",
    left: "calc(50% - 45px)"
  },
  brand: {
    height: 54,
    display: "flex",
    padding: "10px 10px 5px",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    "& img": {
      width: 20
    },
    "& h3": {
      margin: 0,
      fontSize: 16,
      fontWeight: 500,
      paddingLeft: 10,
      color: theme.palette.common.white
    }
  },
  light: {},
  pageTitle: {
    padding: theme.spacing(),
    paddingBottom: theme.spacing(2.5),
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: theme.spacing(1.5)
    },
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 0,
      paddingRight: 0
    },
    "& h4": {
      fontFamily: ["Roboto", "sans-serif"].join(","),
      fontSize: 30,
      fontWeight: 700,
      lineHeight: 1.2,
      [theme.breakpoints.down("md")]: {
        marginBottom: theme.spacing(3)
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: 24,
        marginBottom: theme.spacing(1.5)
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: 20,
        marginBottom: theme.spacing()
      }
    }
  },
  darkTitle: {
    color: theme.palette.type === "dark" ? theme.palette.primary.main : theme.palette.primary.dark
  },
  lightTitle: {
    color: theme.palette.type === "dark" ? theme.palette.common.white : theme.palette.primary.dark
  }
});

export default styles;
